import React from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import FileManager from './pages/FileManager';
import Upload from './pages/Upload';
import Login from './pages/Login';
import PromptManager from './pages/PromptManager'
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';
import Settings from './pages/Settings';
import WebhookManager from './pages/WebhookManager';
import IntegrationManager from './pages/IntegrationManager';
import UserProfile from './pages/UserProfile';
import ApiDevPortal from './pages/ApiDevPortal';
import Copilot from './pages/Copilot/Copilot';
import DocumentDetailPage from './pages/DocumentDetail/DocumentDetailPage';
import OnboardingShell from './pages/Onboarding/OnboardingShell';
import StepCuenta from './pages/Onboarding/StepCuenta';
import StepWorkspace from './pages/Onboarding/StepWorkspace';
import StepEquipo from './pages/Onboarding/StepEquipo';
import StepContacto from './pages/Onboarding/StepContacto';
import PendingApprovalPage from './pages/Onboarding/PendingApprovalPage';
import FiscalProfilePage from './pages/FiscalProfilePage';
import LegalAcceptanceGate from './components/Legal/LegalAcceptanceGate';

function App() {
  const settingsPage = (
    <ProtectedRoute>
      <Settings />
    </ProtectedRoute>
  );

  return (
    <BrowserRouter>
      <LegalAcceptanceGate>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/Login" element={<Navigate to="/login" replace />} />
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Onboarding: cuenta → workspace → contacto → equipo → solicitud pendiente */}
        <Route path="/onboarding" element={<OnboardingShell />}>
          <Route index element={<Navigate to="cuenta" replace />} />
          <Route path="cuenta" element={<StepCuenta />} />
          <Route path="workspace" element={<StepWorkspace />} />
          <Route path="contacto" element={<StepContacto />} />
          <Route path="equipo" element={<StepEquipo />} />
          <Route path="listo" element={<Navigate to="/solicitud-pendiente" replace />} />
        </Route>

        <Route
          path="/solicitud-pendiente"
          element={
            <ProtectedRoute allowPendingApproval>
              <PendingApprovalPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Home"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Filemanager"
          element={
            <ProtectedRoute>
              <FileManager />
            </ProtectedRoute>
          }
        />

        <Route
          path="/upload"
          element={
            <ProtectedRoute>
              <Upload />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Upload"
          element={
            <ProtectedRoute>
              <Upload />
            </ProtectedRoute>
          }
        />

        <Route
          path="/documents/:documentId"
          element={
            <ProtectedRoute>
              <DocumentDetailPage />
            </ProtectedRoute>
          }
        />

        <Route path="/settings" element={settingsPage} />
        <Route path="/Settings" element={<Navigate to="/settings" replace />} />

        <Route
          path="/fiscal"
          element={
            <ProtectedRoute>
              <FiscalProfilePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Prompts/*"
          element={
            <ProtectedRoute>
              <PromptManager />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Webhooks/*"
          element={
            <ProtectedRoute>
              <WebhookManager />
            </ProtectedRoute>
          }
        />



      <Route
          path="/integrations/*"
          element={
            <ProtectedRoute>
              <IntegrationManager />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <UserProfile />
            </ProtectedRoute>
          }
        />

        <Route path="/Workspaces/*" element={<Navigate to="/settings#workspace" replace />} />
        <Route path="/workspaces/*" element={<Navigate to="/settings#workspace" replace />} />

        <Route
          path="/api/*"
          element={
            <ProtectedRoute>
              <ApiDevPortal />
            </ProtectedRoute>
          }
        />

        <Route
          path="/Copilot"
          element={
            <ProtectedRoute>
              <Copilot />
            </ProtectedRoute>
          }
        />
        <Route path="/copilot" element={<Navigate to="/Copilot" replace />} />

      </Routes>
      </LegalAcceptanceGate>


      
    </BrowserRouter>
  );
}

export default App;
